import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import './FooterBar.css';
import { InfoDialog } from '../widgets/infoDialog/InfoDialog';

export function FooterBar() {
    const deckCount = useSelector((state) => state?.app?.stats?.totalCount | 0);
    const metaIngestDate = useSelector((state) => state?.app?.stats?.metaIndexDate);

    let timeStamp = '...';
    if (metaIngestDate) {
        const ingestDate = new Date(metaIngestDate);
        timeStamp = `${ingestDate.getMonth() + 1}.${ingestDate.getDate()}.${ingestDate.getFullYear()}`;
    } else {
        timeStamp = '08.03.24';
    }

    return (
        <div className="footerStatusBar">
            <div className="footerStatusBarInner">
                <span className="footerStatusBlock">
                    <span className="footerStatusLabel">SALTY ASS DECKS</span>
                    <span className="footerStatusValue">{deckCount.toLocaleString()}</span>
                </span>
                <span className="footerStatusDivider">/</span>
                <span className="footerStatusBlock footerStatusBlockMeta">
                    <span className="footerStatusLabel">META</span>
                    <span className="footerStatusValue">{timeStamp}</span>
                </span>
                <span className="footerStatusDivider">/</span>
                <span className="footerStatusBlock footerStatusBlockTag">
                    <span className="footerStatusDot" />
                    <span className="footerStatusTag">EXTRA SALTY</span>
                </span>
                {/* Persistent, always-visible Privacy link — required for ad
                    approval and crawlability; must not be buried in the popup. */}
                <Link className="footerPrivacyLink" to="/privacy">
                    PRIVACY
                </Link>
                <span className="footerInfoDialogSlot">
                    <InfoDialog />
                </span>
            </div>
        </div>
    );
}
